<template>
  <div class="main">
    <select-box
      :category="category"
      :base-category="baseCategory"
      class="select-box"
      @submit="submit"
    />
    <prod-list
      ref="prodList"
      :category="category"
      :base-category="baseCategory"
      :conditions="conditions"
    />
  </div>
</template>

<script>
import SelectBox from "@/components/SelectBox";
import CommonHeader from "@/components/CommonHeader";
import CommonFooter from "@/components/CommonFooter";
import ProdList from "@/components/ProdList";
export default {
  name: "ParamsSelect",
  components: {ProdList, SelectBox},
  data() {
    return {
      baseCategory: {},
      category: {},
      conditions: null,
    }
  },
  watch: {
    $route: {
      handler(newVal,oldVal){
        this.baseCategory = {
          catName: this.$route.query.baseCatName,
          catEnName: this.$route.query.baseCatEnName,
        };
        this.category = {
          catName: this.$route.query.tyCatName,
          catEnName: this.$route.query.tyCatEnName,
        };
        this.conditions = null;
      },
    }
  },
  created() {
    this.baseCategory = {
      catName: this.$route.query.baseCatName,
      catEnName: this.$route.query.baseCatEnName,
    };
    this.category = {
      catName: this.$route.query.tyCatName,
      catEnName: this.$route.query.tyCatEnName,
    };
    this.$forceUpdate();
  },

  methods: {
    // 条件搜索
    submit(conditions) {
      this.conditions = conditions;
      this.$refs.prodList.search();
    }
  },
}
</script>

<style scoped>
.select-box {
  margin-top: 50px ;
}
</style>
